import apiFetch from '../apiFetch'

export default function (token, templateTypeId) {
  return apiFetch({ endPoint: `template?templateTypeId=${templateTypeId}`, method: 'GET', body: null, token: token })
}
